module.exports = __webpack_public_path__ + "static/media/0010_LE_SOL_CARRELAGE_EXISTANT.1a07ba61.webp";